import { render, staticRenderFns } from "./WordleInput.vue?vue&type=template&id=c1dbec5c&scoped=true&"
import script from "./WordleInput.vue?vue&type=script&lang=js&"
export * from "./WordleInput.vue?vue&type=script&lang=js&"
import style0 from "./WordleInput.vue?vue&type=style&index=0&id=c1dbec5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dbec5c",
  null
  
)

export default component.exports